const i4_Action_sidebar = {
	selector: '.i4-actionbar', 
	
	render: function () {
		var $actionBar = $(this.selector);
		if ($actionBar.length) {
			$actionBar.addClass('i4-actionbar--hidden');

			var $clickableBar = $('<div></div>').addClass('clickable-bar');
			$clickableBar.on('click', (function() {
				$actionBar.toggleClass('i4-actionbar--hidden');
				$actionBar.toggleClass('i4-actionbar--shown');
			}).bind(this));
			$actionBar.append($clickableBar);

			$actionBar.on('click', (function(event) {
				var target = $(event.target);
				if (target.hasClass('i4-actionbar--hidden')) {
					$clickableBar.trigger('click');
				}
			}).bind(this));

			// show if not empty
			if ($actionBar.find('.c-aggregator__item').length) {
				$clickableBar.trigger('click');
			}
		}	
	}
};
